import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ReactComponent as LxpIcon } from '../assets/icons/svg/intro/LXP.svg';
import { ReactComponent as LogoWhite } from '../assets/icons/svg/intro/logo_white.svg';

export default function IntroPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const authKey = (searchParams.get("auth_key") || "").trim();

        if (authKey) {
            navigate(`/auth?filterKey=${encodeURIComponent(authKey)}`, { replace: true });
            return;
        }

        const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => {
                navigate("/auth", { state: { fromIntro: true } });
            }, 500);
        }, 1300);

        return () => clearTimeout(timer);
    }, [navigate, searchParams]);

    return (
        <div
            className={`
                w-full h-screen bg-[#0075F8] flex flex-col items-center overflow-hidden
                transition-opacity duration-500
                ${fadeOut ? "opacity-0" : "opacity-100"}
            `}
        >
            {/* 중앙 컨테이너: 아이콘+글씨 위, 로고 아래 — justify-between */}
            <div className="
                flex flex-col items-center justify-between
                w-full px-6
                h-full
                pt-[19.7vh] sm:pt-[22vh] md:pt-[25vh]
                pb-[4.9vh] sm:pb-[5.5vh] md:pb-[6vh]
            ">
                {/* 아이콘 + 글씨 그룹 */}
                <div className="flex flex-col items-center gap-4">
                    <LxpIcon className="w-[100px] h-[100px]" />
                    <p className="
                        text-[24px] font-bold leading-[140%]
                        text-center text-white
                        whitespace-pre-line
                    ">
                        {t("intro.greeting")}
                    </p>
                </div>

                {/* 하단 로고 */}
                <LogoWhite className="w-[160px] h-[24px]" />
            </div>
        </div>
    );
}
